import { cn } from '@shared/lib/utils';
import { ClassValue } from 'clsx';

interface TextCellProps {
  text?: string;
  className?: ClassValue;
  type?: 'text' | 'number';
  children?: React.ReactNode;
}

export function TextCell({
  text,
  type = 'text',
  className,
  children,
}: TextCellProps) {
  if (text) {
    return (
      <p
        className={cn('', className, {
          'float-right': type === 'number',
        })}
      >
        {text}
      </p>
    );
  }

  return <>{children}</>;
}
